import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Select, InputNumber, Switch } from 'antd';
import { SurveyType } from '@wellverse/shared-ts';

export const SurveyEdit: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'surveys' });

  return (
    <Edit resource="surveys" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Type" name="type" rules={[{ required: true }]}>
          <Select>
            {Object.values(SurveyType).map((t) => (
              <Select.Option key={t} value={t}>
                {t}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Version" name="version" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
